import API from 'src/plugins/api/api'

export default {
  /**
   * The active, published flows, reloaded each time a picker opens, because flows send no live updates to talk2.
   */
  async loadEnrollableFlows ({ commit }) {
    commit('SET_ENROLLABLE_FLOWS_LOADING', true)

    try {
      const res = await API.V1.flows.enrollable()

      commit('SET_ENROLLABLE_FLOWS', res.data.data)
    } catch (err) {
      this._vm.$handleErrors(err.response)
    } finally {
      commit('SET_ENROLLABLE_FLOWS_LOADING', false)
    }
  }
}
